import type { StatsSnapshot } from '../../../stats/gameplay-snapshot';
import { useCurrencyStore } from '../../zustand/useCurrencyStore';
import { unitStats } from '../../../stats';
import { inspirationReducer } from './inspiration.reducer';
import { EventsManager } from '@game-libs/events-manager';
import { GameplayEvents } from '../../../types/game-events';
import { useDragonHealthStore } from '../../zustand/useDragonHealthStore';

export const thiefReducer = (scratch: StatsSnapshot) => {
  const upgrades = scratch.upgrades.thief;
  const stats = unitStats.thief;
  const { emit } = EventsManager();

  const isPoisonAttack = Math.random() * 100 < (upgrades.poisonDagger.multiplier ?? 0);

  const damage = stats.damagePerTick ?? 0;

  const dragonHealthBefore = useDragonHealthStore.getState().dragonHealth;
  const newDragonHealth = Math.max(0, dragonHealthBefore - damage);
  const goldIncrease = stats.goldGeneration ?? 0;
  const currency = useCurrencyStore.getState();
  const newInspiration = inspirationReducer(currency.inspiration, stats.inspirationGeneration ?? 0, scratch.upgrades);

  if (isPoisonAttack) {
    const poisonDuration = upgrades.lingeringToxin.multiplier || 5;

    useDragonHealthStore.getState().setRemainingPoison(poisonDuration);

    emit(GameplayEvents.POISON_ATTACK_DRAGON);
  }

  useDragonHealthStore.getState().setHealth(newDragonHealth);
  useCurrencyStore.getState().addGold(goldIncrease);
  useCurrencyStore.getState().sync({ inspiration: newInspiration });

};
